import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {

    return (
        <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
            <div className="carousel-inner" role="listbox">
                <div className="item active">
                    <div className="fill" style={{ backgroundImage: "url('../assets/images/banner/concrete-transport-truck-2.jpg')" }}></div>
                    <div className="opacity-extra-medium bg-extra-dark-gray"></div>
                    <div id="triangleleft"><Link to="/services"><div> + </div></Link></div>
                </div>
                <div className="item">
                    <div className="fill" style={{ backgroundImage: "url('../assets/images/banner/concrete-transport-truck.jpg')" }}></div>
                    <div className="opacity-extra-medium bg-extra-dark-gray"></div>
                    <div id="triangleleft"><Link to="/services"><div> + </div></Link></div>
                </div>
            </div>
            <a className="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                <i className="fa fa-angle-left" aria-hidden="true"></i>
                <span className="sr-only">Previous</span>
            </a>
            <a className="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                <i className="fa fa-angle-right" aria-hidden="true"></i>
                <span className="sr-only">Next</span>
            </a>
        </div>
    );
}

export default Banner;
